import { Extension } from '@tiptap/core';
import { getExtensionOption } from '../private/utils/getExtensionOption';

export const enterBehaveExtension = Extension.create({
  addKeyboardShortcuts(this) {
    return {
      Enter: () => {
        this.editor.options.onEnter?.();
        return !getExtensionOption(this.editor, 'enterBehave').createNewLine;
      },
    };
  },
});
